<template>
    <div class="homeInfor clearfloat">
        <div class="homeInforTop clearfloat">
            <div class="pic">
                <img src="../../../../assets/img/mainPage/bn_04.jpg" />
            </div>
            <div class="right">
                <div class="homeInforCont">
                    <div class="tit titLeft">
                        <h2>西安锦威电子科技有限公司</h2>
                    </div>
                    <p>
                        “创建绿色节约型社会”的宗旨
                        ，面向高耗能的工业建筑和民用建筑用户提供自动化、智能化、数字化服务。公司业务范围涵盖自动化、智能化、数字化以及将BIM技术、节能技术、自动化技术、智能化技术、数字化技术融合的机电安装服务。
                    </p>
                    <p class="two-p">
                        公司是集设计、研发、工程管理实施为一体的科技型企业，拥有多项知识产权、专利权并已投入应用，预计为高耗能用户降低能耗15%~40%。
                    </p>
                    <ul class="comp-keyword">
                        <li>
                            <span>2000</span>万
                            <div>公司注资2000万</div>
                        </li>
                        <li>
                            <span>2011</span>年
                            <div>公司成立于2011年</div>
                        </li>
                        <li>
                            <span>4</span>体系
                            <div>4大产品体系</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
/* 走进锦威 */
.homeInforCont {
    padding: 5px 0 0 35px;
}
.homeInforCont h3 {
    margin-bottom: 20px;
    font-size: 28px;
    text-transform: capitalize;
    color: #1182df;
    font-weight: 300;
    line-height: 40px;
}
.homeInforCont p {
    text-indent: 2em;
    margin-bottom: 22px;
    color: #666;
    line-height: 28px;
    font-size: 14px;
}
.pic {
    width: 100%;
    overflow: hidden;
}
.pic img {
    width: 100%;
    -moz-transition: all 0.3s ease-in;
    -webkit-transition: all 0.3s ease-in;
    -o-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
}
.clearfloat:before,
.clearfloat:after {
    content: '';
    display: table;
    line-height: 0;
    visibility: hidden;
}

.clearfloat:after {
    clear: both;
}
.homeInfor .pic {
    float: left;
    width: 48.12%;
    position: relative;
    top: 0px;
}
.homeInfor .right {
    float: right;
    width: 51.88%;
    position: relative;
    top: 0px;
}
.tit {
    text-align: center;
}

.tit h2 {
    font-size: 36px;
    text-transform: capitalize;
    color: #333;
    font-weight: bold;
    margin: 0;
    margin-bottom: 15px;
}

.tit h3 {
    font-size: 16px;
    color: #747474;
    margin: 0;
    margin-bottom: 20px;
}

.tit p {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid #e6e6e6;
    background: #fff;
    display: inline-block;
    position: relative;
    z-index: 1;
}

.tit p span {
    display: block;
    width: 6px;
    height: 6px;
    background: #eaeaea;
    border-radius: 50%;
    display: block;
    margin: auto;
    margin-top: 3px;
}

.tit p:before,
.tit p:after {
    content: '';
    position: absolute;
    top: 5px;
    width: 50px;
    height: 2px;
    background: #e6e6e6;
    z-index: -1;
}

.tit p:before {
    left: 14px;
}

.tit p:after {
    right: 14px;
}
.titLeft {
    text-align: left;
    margin-bottom: 31px;
}

.titLeft p {
    border-color: #186aab;
}

.titLeft p span {
    background: #186aab;
}

.titLeft p:after {
    right: -96px;
}
.comp-keyword {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    color: #505050;
    padding:0 11px 0 8px;
    margin-top:41px;
    li {
        text-align: center;
        > span {
            font-size: 36px;
            font-weight: bold;
            color: #01af57;
        }
    }
}
.two-p {
    margin-top: -5px;
}
</style>
